module.exports = __webpack_public_path__ + "static/img/lajiao.0df3a88a.png";